import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Image from 'react-bootstrap/Image';
import avatar from './img/avatar.png';
import SigniteButton from '../../../ui-elements/signite-button/signiteButton';
import './candidateInfoNav.scss';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef, useMemo } from 'react';
import { useState } from 'react';
import { CandidateService } from '../../../../services/candidateService';
import { useNavigate } from 'react-router-dom';
import Loader from 'react-spinner-loader';
import { addFileUpload } from '../../../../redux/slices/fileUploadSlice';
import axios from 'axios';
import _ from 'lodash';
import { serverConfig } from '../../../../services/server-config';
import { Form, FormControl, ToggleButton } from 'react-bootstrap';
import compensationDetailsSlice from '../../../../redux/slices/compensationDetailsSlice';
import SigniteToggle from '../../../ui-elements/toggle-switch/signiteToggleSwitch';
import { setSearchable } from '../../../../redux/slices/personalDetailSlice';
import { BlandService } from '../../../../services/blandService';
import CallLogPanel from './callLogPanel';
import { useQueryClient, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Formik } from 'formik';
import { UserService } from '../../../../services/userService';
import { Modal } from 'react-bootstrap';
import { decodeJWT } from '../../../../services/candidateService';
import CuratePopup from './curatePopup';
const switchNavStyle = ({ isActive }) => (isActive ? 'nav-link active' : 'nav-link');

const CandidateInfoNav = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [candidateCallStatus, setCandidateCallStatus] = useState('');
  const currentPath = location.pathname;
  const personalDetailsPath = '/candidate/candidate-personal-info';
  const personalDetails = useSelector((state) => state.personalDetails);
  const inputFile = useRef(null);
  const [file, setFile] = useState(null);
  const [callData, setCallData] = useState({})
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const queryClient = useQueryClient();
  const decoded = decodeJWT(window.localStorage.getItem('authToken'));
  const currentUserRole = decoded?.roles;
  const isDataEntryExe = currentUserRole === "DATA_ENTRY_EXE";
  const [approvalRequested, setApprovalRequested] = useState(false);

  const [showCurateModal, setShowCurateModal] = useState(false);
  const handleOpenCurate = () => setShowCurateModal(true);
  const handleCloseCurate = () => setShowCurateModal(false);


  const handleCandidateSelectionChange = async (event) => {
    const callStatus = event.target.value;
    const candidateId = useSelector((state) => state.personalDetails?.candidateId);
    setCandidateCallStatus(callStatus);
    CandidateService.setCallStatus(candidateId, callStatus, setLoader);
  };
  const [loader, setLoader] = useState(false);
  const [isCallPanelOpen, setCallPanelOpen] = useState(false)
  const dispatch = useDispatch();
  const fileUploadHandler = (response) => {
    setFile(response.blob);
    dispatch(addFileUpload({ dp: [response.fileHandle] }));
    alert('Remember to submit to apply DP Change');
  };

  const candidateId = useSelector((state) => state.personalDetails?.candidateId);

  const handleRequestApproval = async () => {
    if (!candidateId) return;
    try {
      setLoader(true);
      await CandidateService.requestCandidateApproval(candidateId);
      alert('Candidate approval requested successfully.');
      setApprovalRequested(true);
    } catch (error) {
      alert(_.get(error, 'response.data.message', 'Error requesting approval'));
    } finally {
      setLoader(false);
    }
  };

  const handleChange = async (event) => {
    const currentValue = event.target.value === 'false';
    const candidateId = _.get(personalDetails, 'candidateId');
    const searchableStatus = currentValue ? 'ACTIVE' : 'DEACTIVATED';

    try {
      setLoader(true);
      const response1 = await CandidateService.setSearchableStatus(candidateId, searchableStatus, setLoader);
      dispatch(setSearchable({ searchStatus: searchableStatus }));
    } catch (error) {
      let errorMessage = _.get(error, "response.data.message", "");
      if (_.get(error, "response.status") === 403 && errorMessage.includes("unapproved candidate")) {
        errorMessage = "Cannot activate search for Unvalidated candidate";
      }
      alert(errorMessage);
    } finally {
      setLoader(false);
    }
  };

  const handleFileChange = (event) => {
    if (event.target.files[0]) {

      const candidateId = _.get(personalDetails, 'candidateId');
      const fileName = event.target.files[0].name;
      const idxDot = fileName.lastIndexOf('.') + 1;
      const extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
      if (!(extFile == 'jpg' || extFile == 'jpeg' || extFile == 'png' || extFile == 'gif')) {
        alert('Only jpg,gif and png files are allowed!');
        return;
      }
      if (event.target.files[0].size > parseInt(event.target.size)) {
        alert('File size exceeded the set limit of 1M');
        return;
      }
      const formData = new FormData();
      formData.append('file', event.target.files[0]);

      CandidateService.uploadDp(formData, candidateId, fileUploadHandler, setLoader);
    }
  };
  useEffect(() => {
    const fetchImage = async () => {
      try {
        if (_.get(personalDetails, 'candidate.personalDetails.displayPic[0].path')) {
          const response = await axios.get(
            `https://${serverConfig.serverBaseAddress}/signite/file/download?path=` +
            _.get(personalDetails, 'candidate.personalDetails.displayPic[0].path'),
            {
              headers: CandidateService.getAuthHeader(),
              responseType: 'arraybuffer',
            }
          );

          const imageBlob = new Blob([response.data], { type: 'image/jpeg' });
          const url = URL.createObjectURL(imageBlob);

          setFile(url);
        }
      } catch (error) {
        console.error('Error fetching image:', error);
      }
    };
    setCandidateCallStatus(_.get(personalDetails, 'callStatus'));

    const isApprovalRequested = _.get(personalDetails, 'approvalRequested') === 'Y';
    setApprovalRequested(isApprovalRequested);

    fetchImage();
  }, [personalDetails]);

  const {
    pdSubmitted,
    weSubmitted,
    edSubmitted,
    cdSubmitted,
    vaSubmitted,
    tlSubmitted,
  } = personalDetails || {};

  const getTickClass = (submitted) => (submitted === 'Y' ? 'text-success' : 'text-secondary');


  const handleAssignClick = async () => {
    try {
      const response = await UserService.getAllUsers(0, 50);
      setUsers(response?.data?.users || []);
      setShowAssignModal(true);
    } catch (error) {
      alert("Failed to load users for assignment");
    }
  };

  const handleCloseAssign = () => {
    setShowAssignModal(false);
    setSelectedUser("");
  };


  const handleConfirmAssign = async () => {
    if (!selectedUser || !candidateId) return;

    try {
      await UserService.assignCandidate(selectedUser, candidateId);
      dispatch(setSearchable({ assignedTo: { username: selectedUser } }));
      alert(`Candidate ${candidateId} assigned to ${selectedUser}`);
      queryClient.invalidateQueries({ queryKey: ["data"] });
      handleCloseAssign();
    } catch (error) {
      alert(_.get(error, "response.data.message", "Error during assignment"));
    }
  };

  return (
    <Card style={{ minHeight: 228 }}>
      <Loader show={loader} type="body" stack="vertical" message="Loading Data" />
      <Card.Body style={{ paddingBottom: 0 }}>
        <CallLogPanel data={callData} isCallPanelOpen={isCallPanelOpen} setCallPanelOpen={setCallPanelOpen}></CallLogPanel>
        <Row
          style={{
            borderBottom: '1px solid rgba(81, 111, 144, 0.3)',
            paddingBottom: 24,
          }}
        >
          <Col>
            <Row
              style={{
                borderRight: '1px solid rgba(81, 111, 144, 0.3)',
              }}
            >
              <Col xxl={3} xl={3} md={3} lg={3}>
                <img src={file || avatar} width={128} height={128} roundedCircle></img>
              </Col>
              <Col xxl={9} xl={9} md={3} lg={9}>
                <SigniteButton
                  variant="primary"
                  className={currentPath === personalDetailsPath ? '' : 'invisible'}
                  style={{
                    marginTop: 24,
                    height: 40,
                    width: 137,
                    marginBottom: 16,
                  }}
                  onClick={() => inputFile.current.click()}
                >
                  Upload Image
                </SigniteButton>
                <SigniteButton
                  variant="primary"
                  style={{
                    marginTop: 24,
                    marginLeft: 5,
                    height: 40,
                    width: 137,
                    marginBottom: 16,
                  }}
                  className={currentPath === personalDetailsPath ? '' : 'invisible'}
                  onClick={() => {
                    dispatch(addFileUpload({ dp: [] }));
                    setFile(avatar);
                    alert('Remember to submit to apply DP Removal');
                  }}
                >
                  Remove Image
                </SigniteButton>

                <input
                  type="file"
                  accept="image/*"
                  size={1024 * 1024}
                  id="file"
                  ref={inputFile}
                  onChange={handleFileChange}
                  style={{ display: 'none' }}
                />
                <div>
                  <span className={currentPath === personalDetailsPath ? 'signiteLabelS1' : 'invisible'}>
                    Note : JPG, GIF or PNG. Max size of 1MB
                  </span>
                </div>
                <SigniteButton
                  variant="primary"
                  style={{
                    marginTop: 24,
                    marginLeft: 5,
                    height: 40,
                    width: 137,
                    marginBottom: 16,
                  }}
                  className={currentPath === personalDetailsPath ? '' : 'invisible'}
                  onClick={async () => {
                    try {
                      let response = await BlandService.initiateCall(_.get(personalDetails, 'candidateId'));
                      alert("Call initiated, please check call status after 15-20 mins.");

                    } catch (err) {
                      alert('Error initiating call:', err.message || err);
                    }

                  }}
                >
                  Initiate Call
                </SigniteButton>
                <SigniteButton
                  variant="primary"
                  style={{
                    marginTop: 24,
                    marginLeft: 5,
                    height: 40,
                    width: 137,
                    marginBottom: 16,
                  }}
                  className={currentPath === personalDetailsPath ? '' : 'invisible'}
                  onClick={async () => {
                    try {
                      let response = await BlandService.getCallStatus(_.get(personalDetails, 'candidateId'));
                      if (response.status == '200') {
                        setCallData(response.data);
                        setCallPanelOpen(true)
                      }
                    } catch (err) {
                      if (err.response && err.response.status === 404) {
                        alert('No call logs found for this candidate.');
                      } else {
                        alert('Something went wrong while fetching call logs. Please try again.');
                      }
                    }

                  }}
                >
                  Call Status
                </SigniteButton>
                <div className="signiteLabelS1" style={{ marginBottom: 8, display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <span>Candidate Profile Status:</span>
                  {personalDetails?.status === 'VALIDATED' ? (
                    <>
                      <span style={{ fontWeight: 'bold', color: '#198754' }}>Validated</span>
                      <i className="fas fa-check-circle text-success" title="Candidate is Validated" />
                    </>
                  ) : (
                    <>
                      <span style={{ fontWeight: 'bold', color: '#dc3545' }}>Unvalidated</span>
                      <i className="fas fa-exclamation-circle" style={{ color: '#dc3545' }} title="Candidate is Unvalidated" />
                    </>
                  )}
                </div>

                <div className="signiteLabelS1">
                  Candidate Search Status:
                  <SigniteToggle
                    id={`searchStatus`}
                    dataYES={'ACTIVE'}
                    dataNO={'DEACTIVATED'}
                    fieldInput={{
                      onChange: handleChange,
                      value: _.get(personalDetails, 'searchStatus') === 'ACTIVE',
                    }}
                  />
                </div>
                <div className="signiteLabelS1">
                  <Form.Label>Candidate Call Status:</Form.Label>
                  <Form.Control
                    as="select"
                    style={{ width: '50%', fontSize: '14px' }}
                    onChange={handleCandidateSelectionChange}
                    value={candidateCallStatus}
                  >
                    <option>TO_BE_CONTACTED</option>
                    <option>NOT_RECEIVING_CALL</option>
                    <option>CALL_BACK_LATER</option>
                    <option>CALL_COMPLETED</option>
                    <option>SWITCHED_OFF</option>
                    <option>WRONG_NUMBER</option>
                    <option>TEMPORARILY_OUT_OF_SVC</option>
                  </Form.Control>
                </div>


                <Modal show={showAssignModal} onHide={handleCloseAssign}>
                  <Modal.Header closeButton>
                    <Modal.Title>Assign Candidate</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group>
                      <Form.Label>Select User</Form.Label>
                      <Form.Control
                        as="select"
                        value={selectedUser}
                        onChange={(e) => setSelectedUser(e.target.value)}
                      >
                        <option value="">-- Select User --</option>
                        {users.map((user) => (
                          <option key={user.username} value={user.username}>
                            {user.username}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Modal.Body>
                  <Modal.Footer>
                    <SigniteButton variant="secondary" onClick={handleCloseAssign}>
                      Cancel
                    </SigniteButton>
                    <SigniteButton variant="primary" onClick={handleConfirmAssign}>
                      Confirm
                    </SigniteButton>
                  </Modal.Footer>
                </Modal>

              </Col>
            </Row>
          </Col>
          <Col>
            <Row>
              <Col>
                <div style={{ paddingLeft: 40 }}>
                  <span>Candidate Signite ID:</span>
                </div>
                <div className="signiteCardLabel" style={{ paddingTop: 24, paddingLeft: 40 }}>
                  <span>Last Updated By:</span>
                </div>
                <div className="signiteCardLabel" style={{ paddingTop: 24, paddingLeft: 40 }}>
                  <span>Last Updated Date:</span>
                </div>
              </Col>
              <Col style={{ color: '#516F90' }}>
                <div className="signiteCardLabel" style={{ paddingLeft: 40 }}>
                  <span>{_.get(personalDetails, 'candidateId')}</span>
                </div>
                <div className="signiteCardLabel" style={{ paddingTop: 24, paddingLeft: 40 }}>
                  <span>{_.get(personalDetails, 'lastUpdatedBy')}</span>
                </div>
                <div className="signiteCardLabel" style={{ paddingTop: 24, paddingLeft: 40 }}>
                  <span>
                    {_.get(personalDetails, 'lastUpdated')
                      ? new Date(_.get(personalDetails, 'lastUpdated')).toDateString()
                      : ''}
                  </span>
                </div>
              </Col>
              <div style={{ marginTop: 24, marginLeft: 5, display: "flex", alignItems: "center", gap: "8px" }}>
                <div
                  style={{
                    display: 'inline-block',
                    cursor: approvalRequested ? 'not-allowed' : 'pointer',
                  }}
                >
                  <SigniteButton
                    variant="primary"
                    disabled={approvalRequested}
                    onClick={!approvalRequested ? handleRequestApproval : undefined}
                    style={{
                      marginTop: 24,
                      marginLeft: 5,
                      height: 40,
                      width: 200,
                      marginBottom: 16,
                      opacity: approvalRequested ? 0.6 : 1,
                      pointerEvents: approvalRequested ? 'none' : 'auto',
                    }}
                  >
                    {approvalRequested ? 'Approval Requested' : 'Request Candidate Approval'}
                  </SigniteButton>
                </div>


              </div>

              <div style={{ marginTop: 16, marginLeft: 5, display: "flex", alignItems: "center", gap: "8px" }}>
                {!isDataEntryExe && (
                  _.get(personalDetails, "assignedTo.username") ? (
                    <>
                      <span>Assigned to :</span>
                      {_.get(personalDetails, "assignedTo.username") && (
                        <span style={{ color: '#F35824' }}>{_.get(personalDetails, "assignedTo.username")}</span>
                      )}
                      <SigniteButton
                        variant="primary"
                        style={{ height: 36 }}
                        onClick={handleAssignClick}
                      >
                        {_.get(personalDetails, "assignedTo.username") ? "Reassign" : "Assign"}

                      </SigniteButton>

                    </>
                  ) : (
                    <>
                      <SigniteButton
                        variant="primary"
                        style={{ height: 36 }}
                        onClick={handleAssignClick}
                      >
                        Assign
                      </SigniteButton>
                    </>
                  )
                )}
              </div>

              {!isDataEntryExe && (
                <div style={{ marginTop: 16, marginLeft: 5 }}>
                  <SigniteButton
                    variant="primary"
                    style={{ height: 36, width: 120 }}
                    onClick={handleOpenCurate}
                  >
                    Curate
                  </SigniteButton>

                  <CuratePopup
                    show={showCurateModal}
                    onClose={handleCloseCurate}
                    candidateId={candidateId}
                  />
                </div>
              )}
            </Row>
          </Col>
        </Row>
        <Row>
          <Nav className="candidateNav" activeKey="/candidate">
            <Nav.Item>
              <div
                className={switchNavStyle({ isActive: location.pathname.includes('candidate-personal-info') })}
                style={{ cursor: 'pointer', pointerEvents: personalDetails?.candidateId ? null : 'none' }}
                onClick={() => navigate('candidate-personal-info', { replace: true })}
              >
                <p className='admin-candidate-nav-p'>
                  Personal Details <i className={`fas fa-check-circle ms-2 ${getTickClass(pdSubmitted)}`} />
                </p>
              </div>
            </Nav.Item>
            <Nav.Item>
              <div
                className={switchNavStyle({ isActive: location.pathname.includes('candidate-work-experience') })}
                style={{ cursor: 'pointer', pointerEvents: personalDetails?.candidateId ? null : 'none' }}
                onClick={() => navigate('candidate-work-experience', { replace: true })}
              >
                <p className='admin-candidate-nav-p'>
                  Work Experience <i className={`fas fa-check-circle ms-2 ${getTickClass(weSubmitted)}`} />
                </p>
              </div>
            </Nav.Item>
            <Nav.Item>
              <div
                className={switchNavStyle({ isActive: location.pathname.includes('candidate-education-details') })}
                style={{ cursor: 'pointer', pointerEvents: personalDetails?.candidateId ? null : 'none' }}
                onClick={() => navigate('candidate-education-details', { replace: true })}
              >
                <p className='admin-candidate-nav-p'>
                  Education Details <i className={`fas fa-check-circle ms-2 ${getTickClass(edSubmitted)}`} />
                </p>
              </div>
            </Nav.Item>
            <Nav.Item>
              <div
                className={switchNavStyle({ isActive: location.pathname.includes('candidate-compensation-details') })}
                style={{ cursor: 'pointer', pointerEvents: personalDetails?.candidateId ? null : 'none' }}
                onClick={() => navigate('candidate-compensation-details', { replace: true })}
              >
                <p className='admin-candidate-nav-p'>
                  Compensation Details <i className={`fas fa-check-circle ms-2 ${getTickClass(cdSubmitted)}`} />
                </p>
              </div>
            </Nav.Item>
            <Nav.Item>
              <div
                className={switchNavStyle({ isActive: location.pathname.includes('candidate-value-adds') })}
                style={{ cursor: 'pointer', pointerEvents: personalDetails?.candidateId ? null : 'none' }}
                onClick={() => navigate('candidate-value-adds', { replace: true })}
              >
                <p className='admin-candidate-nav-p'>
                  Value Adds <i className={`fas fa-check-circle ms-2 ${getTickClass(vaSubmitted)}`} />
                </p>
              </div>
            </Nav.Item>
            <Nav.Item>
              <div
                className={switchNavStyle({ isActive: location.pathname.includes('candidate-timeline') })}
                style={{ cursor: 'not-allowed', pointerEvents: personalDetails?.candidateId ? null : 'none' }}
              >
                <p className='admin-candidate-nav-p'>Timeline</p>
              </div>
            </Nav.Item>
            {!isDataEntryExe && (
              <Nav.Item>
                <div
                  className={switchNavStyle({ isActive: location.pathname.includes('candidate-curated-clients') })}
                  style={{ cursor: 'pointer', pointerEvents: personalDetails?.candidateId ? null : 'none' }}
                  onClick={() => navigate('candidate-curated-clients')}
                >
                  <p className='admin-candidate-nav-p'>
                    Curated Clients
                  </p>
                </div>
              </Nav.Item>
            )}
          </Nav>
        </Row>
      </Card.Body>
    </Card>
  );
};
export default CandidateInfoNav;